import { isEmpty } from 'lodash-es';

import ILocation from '../../types/ILocation';

export const formatLocation = (location: ILocation | null) => {
  if (location) {
    let state = '';
    if (isEmpty(location)) {
      return '';
    }
    if (isEmpty(location.city) && isEmpty(location.state) && isEmpty(location.country)) {
      return location.continent;
    }
    if (location.state?.length > 0) {
      if (location.stateCode?.length == 2) {
        state = `${location.stateCode}, `;
      } else {
        state = `${location.state}, `;
      }
    }
    return `${location.city ?? ''} ${state} ${location.country}`;
  }
  return '';
};
